import { SideBarElementProps } from "@/common/types";
import { Link, useLocation } from "react-router";
import Typography from "../Typography/Typography";

export default function TabElement({ element }: Partial<SideBarElementProps>) {
  const location = useLocation();
  const { icon, label, to } = element!;
  const style = location.pathname.includes(to)
    ? "flex gap-1 bg-primary text-white rounded-lg px-4 py-[6px] text-[14px] font-kanit font-normal leading-5 text-nowrap"
    : "flex gap-1 bg-primaryDim text-primary rounded-lg px-4 py-[6px] text-[14px] font-kanit font-normal leading-5 text-nowrap";
  return (
    <Link to={to} className={style} key={to}>
      {icon}
      <Typography type="span">{label}</Typography>
    </Link>
  );
}
